export default __webpack_public_path__ + "static/media/je.c637d378.svg";